
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  @Component({
    computed: {
      ...mapGetters([
        'isLoading',
        'isLinkingCallbackLoading',
        'platformName'
      ])
    }
  })
  export default class Header extends Vue {
    data() {
      return {
        frontUrl: '',
        frontTitle: '',
        headerImage: '',
        headerTitle: '',
      }
    }

    created() {
      this.initFrontTitle();
      this.$data.frontUrl = this.$data.RCEnvironment.VUE_APP_FRONT_URL;
      this.setHeaderSettings();
    }

    public mounted(): void {
      this.$watch(() => this.$store.getters.platformName, (params) => {
        this.initFrontTitle();
      });
    }

    private initFrontTitle(): void {
      this.$data.frontTitle = "Go to " + this.$store.getters.platformName;
    }

    private setHeaderSettings(): void {
      let headerImage = '';
      let headerTitle = '';

      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TWO-POINT-STUDIOS') {
        headerImage = "tps/header-icon.png";
        headerTitle = "Two Point County Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'CREATIVE-ASSEMBLY') {
        headerImage = "ca/header-icon.png";
        headerTitle = "Creative Assembly Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'SANDBOX') {
        headerImage = "sandbox/header-icon.png";
        headerTitle = "Sandbox Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'FOCUS') {
        headerImage = "focus/header-icon.png";
        headerTitle = "Focus Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'AVALANCHE') {
        headerImage = "avlc/header-icon.svg";
        headerTitle = "Avalanche Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'STILLFRONT') {
        headerImage = "https://medias.community.playsupremacy.com/account/header-icon.png";
        headerTitle = "Supremacy Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'UBISOFT') {
        headerImage = "https://medias.community.ubisoft.com/account/header-icon.svg";
        headerTitle = "Ubisoft Header Icon";
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'UBISOFT-PLAYER-COUNCIL') {
        headerImage = "https://medias.community.playercouncil.gg/account/header-icon.svg";
        headerTitle = "Player Council Header Icon";
      } else if (["LOCAL", "STAGING", "TEST", "PROD"].includes(this.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
        headerImage = "Logo-Amplifiers-Account.svg";
        headerTitle = "Amplitude Header Icon";
      }

      if (!["STILLFRONT", "UBISOFT", "UBISOFT-PLAYER-COUNCIL"].includes(this.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
        headerImage = require('@/assets/images/' + headerImage);
      }

      this.$set(this.$data, "headerImage", headerImage);
      this.$set(this.$data, "headerTitle", headerTitle);
    }
  }
